module.exports = __webpack_public_path__ + "img/WINTER HAT BN.3842d23.svg";